import { useMutation, useQueryClient } from "@tanstack/react-query"
import {
  useCreateResource,
  useDeleteResource,
  useEditResource,
  usePaginatedResource,
  useResourceItem,
} from "./useCrudResource"

import {
  createBulkVehicleLcDocuments,
  createVehicleLcDocument,
  deleteVehicleLcDocument,
  getVehicleLcDocumentGroups,
  getVehicleLcDocument,
  getVehicleLcDocuments,
  updateVehicleLcDocument,
} from "api/vehicleLcDocumentApi"

export const VEHICLE_LC_DOCUMENT_QUERY_KEY = "vehicle-lc-documents"
export const VEHICLE_LC_DOCUMENT_GROUP_QUERY_KEY = `${VEHICLE_LC_DOCUMENT_QUERY_KEY}-groups`

export const useVehicleLcDocuments = (params = {}, enabled = true) =>
  usePaginatedResource(
    VEHICLE_LC_DOCUMENT_QUERY_KEY,
    getVehicleLcDocuments,
    params,
    enabled
  )

export const useVehicleLcDocumentGroups = (params = {}, enabled = true) =>
  usePaginatedResource(
    VEHICLE_LC_DOCUMENT_GROUP_QUERY_KEY,
    getVehicleLcDocumentGroups,
    params,
    enabled
  )

export const useVehicleLcDocument = (id, enabled = true) =>
  useResourceItem(
    VEHICLE_LC_DOCUMENT_QUERY_KEY,
    getVehicleLcDocument,
    id,
    enabled
  )

export const useCreateVehicleLcDocument = () =>
  useCreateResource(createVehicleLcDocument, VEHICLE_LC_DOCUMENT_QUERY_KEY)

export const useEditVehicleLcDocument = () =>
  useEditResource(updateVehicleLcDocument, VEHICLE_LC_DOCUMENT_QUERY_KEY)

export const useDeleteVehicleLcDocument = () =>
  useDeleteResource(deleteVehicleLcDocument, VEHICLE_LC_DOCUMENT_QUERY_KEY)

export const useBulkCreateVehicleLcDocuments = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createBulkVehicleLcDocuments,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [VEHICLE_LC_DOCUMENT_QUERY_KEY] })
      queryClient.invalidateQueries({
        queryKey: [VEHICLE_LC_DOCUMENT_GROUP_QUERY_KEY],
      })
    },
  })
}
